import React from "react";
import {
  UncontrolledButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import "./DropDown.css";

const DropDown = (props) => {
  const isDisabled =
    !props.downloadReportDropdown ||
    props.downloadReportDropdown.length === 0 ||
    !props.enable_report;

  return (
    <React.Fragment>
      {isDisabled ? (
        <div>
          <DropdownToggle className="disabled">DOWNLOAD Reports</DropdownToggle>
          <DropdownMenu>
            {props.downloadReportDropdown &&
              props.downloadReportDropdown.map((items, index) => {
                return (
                  <div key={index}>
                    <DropdownItem className="download-Dropdownitem">
                      {items.relation_group_name}
                    </DropdownItem>
                  </div>
                );
              })}
          </DropdownMenu>
        </div>
      ) : (
        <UncontrolledButtonDropdown>
          <DropdownToggle caret className="download-DropdownToggle">
            DOWNLOAD REPORTS
          </DropdownToggle>
          <DropdownMenu>
            {props.downloadReportDropdown &&
              props.downloadReportDropdown.map((items, index) => {
                return (
                  <div key={index}>
                    <DropdownItem
                      className="download-Dropdownitem"
                      onClick={() =>
                        props.handlePdfDownload(
                          items.relation_group_name,
                          items.relation_group_id
                        )
                      }
                    >
                      {items.relation_group_name}
                    </DropdownItem>
                  </div>
                );
              })}
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      )}
    </React.Fragment>
  );
};

export default DropDown;


// WEBPACK FOOTER //
// ./src/new/Components/Reports/Download-Reports/DropDown/DropDown.jsx